import type { SearchBoxProps } from '@coveo/headless';

import { DEFAULT_SUGGESTIONS_COUNT } from '../../../constants/search.constants';

export const DEFAULT_SEARCH_PROPS: SearchBoxProps = { options: { numberOfSuggestions: DEFAULT_SUGGESTIONS_COUNT } };
